"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import {
  PRODUCTS_BINDING,
  PRODUCTS_BINDING_INPUT,
} from "@/libs/builder/consts";

export const productCardInputs = [
  {
    name: "sku",
    type: "MagentoProduct",
    required: true,
  },
  {
    name: "badge",
    type: "object",
    subFields: [
      {
        name: "left",
        type: "string",
      },
      {
        name: "right",
        type: "string",
      },
    ],
  },
  {
    name: "isNewBadgeHidden",
    friendlyName: "Hide new badge",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isDiscountBadgeHidden",
    friendlyName: "Hide discount badge",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isDescriptionHidden",
    friendlyName: "Hide description",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isOldPriceHidden",
    friendlyName: "Hide old price",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isCurrentPriceHidden",
    friendlyName: "Hide current price",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isProductColorVariantsHidden",
    friendlyName: "Hide product color variants",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isPrimaryButtonHidden",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "primaryButton",
    type: "object",
    subFields: [
      {
        name: "text",
        type: "string",
      },
      {
        name: "href",
        type: "url",
      },
    ],
  },
  {
    name: "secondaryButton",
    type: "object",
    subFields: [
      {
        name: "text",
        type: "string",
      },
      {
        name: "href",
        type: "url",
      },
    ],
  },
  PRODUCTS_BINDING_INPUT,
] as const satisfies Inputs;

export const ProductCardComponent: RegisteredComponent = {
  name: "ProductCard",
  component: dynamic(
    async () => (await import("./ProductCardWrapper")).ProductCardWrapper
  ),
  inputs: productCardInputs,
  noWrap: true,
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
